module.exports = __webpack_public_path__ + "media/images/category/feature/index/thum-coj_c-193cf95a5202af27cd68403959f997c5.jpg";